import React, {useContext} from 'react'
import {Paper, Card, CardContent, Box} from '@material-ui/core/'
import {companyLogo} from '../../graphql/barcode/queries/companyLogoQuery'
import {Query} from 'react-apollo'
import {entitiesAllFields} from '../../graphql/barcode/queries/entitiesAllFieldsQuery'
import {useTranslation} from 'react-i18next'
import BarcodeLabelPreview from './BarcodeLabelPreview'
import useStyles from './BarcodeWizardPreview.styles'
import BarcodeWizardSheetPreview from './BarcodeWizardSheetPreview'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {BarcodeWizardContext} from '../../context/BarcodeWizard'

function BarcodeWizardPreview(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const {barcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const {entitiesFields, setEntitiesFields} = useContext(BarcodeWizardContext)
  const [fields, setFields] = React.useState(entitiesFields || undefined)
  const [cmpLogo, setCmpLogo] = React.useState('')

  function headerTitle() {
    let title = t('barcode.wizard.preview.build-file')
    if (
      window.location.pathname === '/barcode-wizard-generate-automatic' ||
      window.location.pathname === '/barcode-libray-reprint-generate-automatic' ||
      window.location.pathname === '/barcode-libray-generate-automatic'
    ) {
      title = t('barcode.wizard.preview.position-label')
    }
    return title
  }

  function setFieldsOnLoad(fields) {
    setEntitiesFields(fields)
    setFields(fields)
  }

  return (
    <div>
      <Query
        query={entitiesAllFields}
        variables={{
          accountId: parseInt(userSettings.id),
          token: userSettings.token,
        }}
        onCompleted={data => setFieldsOnLoad(data.entitiesAllFields.fields)}
        fetchPolicy="network-only"
      >
        {({loading, error, data}) => {
          return null
        }}
      </Query>

      <Query
        query={companyLogo}
        variables={{
          accountId: parseInt(userSettings.id),
          token: userSettings.token,
        }}
        onCompleted={data =>
          setCmpLogo(
            process.env.REACT_APP_CLOUDFRONT_URL +
              'uploads' +
              data.companyLogo.url.split('uploads', 2)[1]
          )
        }
        fetchPolicy="network-only"
      >
        {({loading, error, data}) => {
          return null
        }}
      </Query>

      <Paper>
        <Card className={classes.preview}>
          <CardContent classes={{root: classes.center}}>
            <Box fontWeight="bold" m={1}>
              {headerTitle()}
            </Box>
          </CardContent>
          <div hidden={props.viewPNG}>
            <Box borderColor="grey.500" className={classes.firstPreview} clone>
              {barcodeSheetRecord ? (
                <BarcodeWizardSheetPreview
                  sheetRecord={barcodeSheetRecord}
                  page={props.page}
                  startPosition={props.barcodeStartPosition}
                  onClickButton={props.changePosition}
                />
              ) : (
                <Box bgcolor="background.paper" m={8} className={classes.noPreviewSheet}>
                  {t('barcode.wizard.preview.no-preview')}
                </Box>
              )}
            </Box>
          </div>

          <Box borderColor="grey.500" className={classes.labelPreview} clone>
            {barcodeLabelRecord ? (
              <BarcodeLabelPreview
                details={barcodeLabelRecord}
                sheet={barcodeSheetRecord}
                cmpLogo={cmpLogo}
                fields={fields}
              />
            ) : (
              <Box bgcolor="background.paper" m={8} border={1} className={classes.noPreviewLabel}>
                <p>{t('barcode.wizard.preview.no-preview')}</p>
              </Box>
            )}
          </Box>
        </Card>
      </Paper>
      <Box marginBottom={5} marginTop={2} textAlign="center" fontSize={12}>
        <Box fontWeight={700} display={'inline'}>
          {t('barcode.wizard.preview.note')}
        </Box>{' '}
        {t('barcode.wizard.preview.not-align')}
      </Box>
    </div>
  )
}

export default BarcodeWizardPreview
